import type { RootState } from 'store'

export const getSort = (state: RootState) =>
  typeof state.requestWines?.sorting === 'string'
    ? state.requestWines.sorting
    : ''
export const getPageInfo = (state: RootState) =>
  state.requestWines?.pageInfo ?? null
export const getLoading = (state: RootState) => state.requestWines?.loading
export const getError = (state: RootState) => state.requestWines?.error
export const getItems = (state: RootState) => state.requestWines?.items
export const getRequest = (state: RootState) =>
  state?.requestWines?.item ?? null
export const getQuery = (state: RootState) => state?.requestWines?.query ?? ''
export const getFilters = (state: RootState) =>
  state?.requestWines?.filters ?? []
